import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useGetLocations from "../Hooks/useGetLocation";
import useGetPrograms from "../Hooks/useGetPrograms";
import useGetSemester from "../Hooks/useGetSemester";
import useGetSubjects from "../Hooks/useGetSubjects";
import DataStudentGrid from "../Components/DataGrid/DataStudentGrid";
import StudentInfoSession from "../Components/Dialogs/StudentInfoSession";
import FileDownloadLoader from "../Components/Loaders/FileDownloadLoader";
import { useGetStudents } from "../Hooks/useGetStudents";
import StudentFilters from "../Components/Filters/StudentFilters";
import { AWS_LINK, DEV_LINK } from "../Static/static";
import { setSnackError } from "../Reducers/snackErrors";

const options = [
  { label: "All", value: "all" },
  { label: "Group by students", value: "group_students" },
];

const StudentData = () => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role);
  const [inputKey, setInputKey] = useState(null);

  const [openStudentInfo, setOpenStudentInfo] = useState(false);
  const [assessmentInfo, setAssessmentInfo] = useState([]);
  const [sessionInfo, setSessionInfo] = useState([]);

  const { locations } = useGetLocations(role);
  const { programs } = useGetPrograms(role);
  const { subjects } = useGetSubjects(role);
  const { students, downloading, loading: students_loading, totalRows,
    setDownloading, searchForStudents, getStudentInfo, requestStudentFile} = useGetStudents();
  const { semesters, loading: semester_loading, error: semester_error } = useGetSemester(role);


  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });


  const closeStudentInfo = () => {
    setOpenStudentInfo(false);
    setAssessmentInfo([]);
    setSessionInfo([]);
  };

  const viewSessionInfo = async (id) => {
    const studentInfo = await getStudentInfo(id);
    if (studentInfo) {
        setOpenStudentInfo(true);
        setSessionInfo(studentInfo.data); 
        setAssessmentInfo(studentInfo.assessment_data);
    }
  };

  function download(url) {
    const a = document.createElement("a");
    a.href = url;
    a.download = "download.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  
  useEffect(() => {
    if (!inputKey) { setDownloading(false); return; }
    let eventSource;
    const token = role.token;
    const LINK = process.env.NODE_ENV === "production" ? AWS_LINK : DEV_LINK;
    // Create SSE connection
    eventSource = new EventSource(
      LINK+`/api/get_student_data_stream?input_key=${inputKey}&token=${token}`
    );
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const { status, url } = data;
  
        if (status === "DONE" && url) {
            download(url)
            setInputKey(null);
            setDownloading(false);
            eventSource.close();
        }
  
        if (status === "ERROR") {
          dispatch(
            setSnackError({ title: "Error", body: "Backend error." })
          );
  
          setDownloading(false);
          eventSource.close();
        }
      } catch (err) {
        console.error("SSE parse error:", err);
      }
    };
  
    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
  
      dispatch(
        setSnackError({
          title: "Error",
          body: "Connection lost or failed",
        })
      );
  
      setDownloading(false);
      eventSource.close();
    };
  
    return () => {
      if (eventSource) {
        eventSource.close(); // cleanup on unmount
      }
    };
  }, [inputKey])

  const requestFile = async (values, index) => {
    const key = await requestStudentFile(values, options[index].value);
    if ( key ) { setInputKey(key) ;} 
  }
  
  return (
    <Box p={2}>
      <Typography variant="h6" mb={2} sx={{ fontWeight: 600, textAlign: { xs: 'left', md: 'left' } }}>
        Student Data
      </Typography>

      <StudentFilters 
        onFilterChange={searchForStudents} 
        requestFile={requestFile} 
        subjects={subjects} 
        programs={programs} 
        semester_loading={semester_loading} 
        semesters={semesters} 
        locations={locations} 
        paginationModel={paginationModel}
        />

      <FileDownloadLoader open={downloading} />

      <DataStudentGrid
        loading={students_loading} 
        data={students} 
        viewSessionInfo={viewSessionInfo} 
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[10, 25, 50]}
        rowCount={totalRows} 

        
        />

        
      <StudentInfoSession 
        sessionInfo={sessionInfo} 
        assessmentInfo={assessmentInfo} 
        open={openStudentInfo} 
        close={closeStudentInfo} />
    </Box>
  );
};

export default StudentData;